import { utahExtent, initCenter, initZoom } from "./constants";
import { fromLonLat } from 'ol/proj';
import { transformExtent, transform } from 'ol/proj';
import View from 'ol/View';
import { ZoomToExtent, defaults as defaultControls } from 'ol/control';
import Themes from 'ol-themes-ext'
import Map from 'ol/Map'


/*
    This helper function unwraps some information from the change event
    Here we extract the extent, center, and zoom from the map
    This way our higher level business logic doesnt need to know about ol
*/
const unwrapExtentChange = (evt) => {
    const map = evt.map;
    const view = map.getView();
    const extent = view.calculateExtent(map.getSize());
    const zoom = view.getZoom();
    const proj = map.getView().getProjection().getCode();

    // Get the center from the openlayers map
    let center = map.getView().getCenter();
    // Transform the center to a lat/lon
    let centerLatLon = transform(center, 'EPSG:3857', 'EPSG:4326');

    let transformed = transformExtent(extent, proj, "EPSG:4326");

    return { extent: transformed, zoom: zoom, center: centerLatLon };
}


/*
    This helper function unwraps some information from the click event
    This way our higher level business logic doesnt need to know about ol
*/
const unwrapMapClick = (evt) => {
    return evt.pixel;
}


const createMap = (target) => {
    let view = new View({
        center: fromLonLat(initCenter),
        zoom: initZoom,
        constrainResolution: true,
        projection: 'EPSG:3857'
      });

      let controls = defaultControls().extend([
        new ZoomToExtent({
          extent: transformExtent(utahExtent, "EPSG:4326", "EPSG:3857"),
        }),
      ]);

      let newMapObj = new Map({
        target: target,
        controls: controls,
        layers: [ ],
        view: view
      });
      
      newMapObj = new Themes(newMapObj);

      window.mapObj = newMapObj;

      newMapObj.getView().fit(transformExtent(utahExtent, "EPSG:4326", "EPSG:3857"), { duration: 1000 });

      return newMapObj;
}

const exports = {
    createMap,
    unwrapExtentChange,
    unwrapMapClick
};

export default exports;